var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMoment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 82,
    viewBox: "0 0 106 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.0044 79.9058C80.9524 80.4557 81.356 80.9435 81.9058 80.9956L90.8658 81.8431C91.4157 81.8951 91.9035 81.4916 91.9556 80.9417C92.0076 80.3919 91.604 79.904 91.0542 79.852L83.0897 79.0986L83.8431 71.1342C83.8951 70.5843 83.4916 70.0965 82.9417 70.0444C82.3919 69.9924 81.904 70.396 81.852 70.9458L81.0044 79.9058ZM1 1L0.926128 1.99727C27.9022 3.9955 64.1563 10.3359 85.5476 22.7646C96.252 28.9841 102.957 36.5603 103.276 45.6414C103.596 54.7624 97.5023 65.8793 81.3626 79.2294L82 80L82.6374 80.7706C98.8977 67.3207 105.629 55.6626 105.274 45.5711C104.918 35.4397 97.448 27.3659 86.5524 21.0354C64.7437 8.36411 28.0978 2.0045 1.07387 0.00273222L1 1Z",
    fill: "#FFC917"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoment);
export default __webpack_public_path__ + "static/media/icon-moment.6143e670536ac105c3e3731aa182a935.svg";
export { ForwardRef as ReactComponent };